import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import contactPortalService from '../services/contactPortal';
import './ContactPortal.scss';

const ContactLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { fetchUser } = useAuth();

  const [form, setForm] = useState({ email: '', password: '' });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const accountPendingActivation = error.toLowerCase().includes('activada');

  const onChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (error) setError('');
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      await contactPortalService.login(form.email.trim(), form.password);
      await fetchUser();

      const redirectTo = location.state?.from || '/consultas-y-reclamos';
      navigate(redirectTo, { replace: true });
    } catch (err) {
      const message = err.response?.data?.detail || 'No se pudo iniciar sesion.';
      setError(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-portal-auth-page">
      <div className="auth-card">
        <h1>Ingreso de Contactos</h1>
        <p>Inicia sesion para consultar el estado de tus tareas.</p>

        <form onSubmit={onSubmit}>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={form.email}
            onChange={(e) => onChange('email', e.target.value)}
            required
          />

          <label htmlFor="password">Contrasena</label>
          <input
            id="password"
            type="password"
            value={form.password}
            onChange={(e) => onChange('password', e.target.value)}
            required
          />

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>

        <p className="auth-footer">
          No tenes cuenta? <Link to="/contactos/registrarse">Registrate</Link>
        </p>
        <p className="auth-footer">
          <Link to="/contactos/recuperar-contrasena">Olvide mi contrasena</Link>
        </p>
        <p className="auth-footer">
          <Link to="/contactos/reenviar-activacion">Reenviar activacion</Link>
        </p>
        {accountPendingActivation && (
          <p className="auth-footer">
            Tu cuenta no esta activa. <Link to="/contactos/reenviar-activacion">Solicita un nuevo enlace</Link>
          </p>
        )}
      </div>
    </div>
  );
};

export default ContactLogin;
